import { useEffect } from 'react';
import { LOCAL_STORAGE, LocalStorage } from '@blink/components/src/utils';

import { useWalletConnect } from '@/shared/hooks/useWalletConnect';
import { cleanLocalStorageWalletConnect } from '@/shared/utils/helpers';
import { toast } from '@/shared/hooks/useToast';

export const useWalletStatusProps = () => {
    const walletConnectUri = LocalStorage.getItem(LOCAL_STORAGE.WALLET_CONNECT_URI) as string;
    const walletConnectMarginAddress =
        LocalStorage.getItem(LOCAL_STORAGE.WALLET_CONNECT_MARGIN_ADDRESS) || '';

    const walletConnectProps = useWalletConnect({
        marginAccountAddress: walletConnectMarginAddress,
        showErrorMessage: false,
    });

    useEffect(() => {
        if (!walletConnectProps.handlePair || !walletConnectUri) {
            return;
        }
        (async () => {
            try {
                await walletConnectProps.handlePair(walletConnectUri);
            } catch (e) {
                console.warn('WC:connection_lost');
                cleanLocalStorageWalletConnect();
                toast({
                    title: 'Disconnected',
                    description: 'Wallet has been disconnected. Please reconnect.',
                    variant: 'error',
                });
            }
        })();
    }, []);

    const disconnectWallet = () => {
        const topic = LocalStorage.getItem(LOCAL_STORAGE.WALLET_CONNECT_TOPIC) as string;
        if (topic) {
            walletConnectProps.disconnect(topic);
        }
    };

    return {
        disconnect: disconnectWallet,
    };
};
